import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

type Application = {
    id: number
    title: string  
    value: string
    category: any
}

type ApplicationDto = {
    title: string  
    value: string
    category: number[]
}

export const ApplicationsApi = createApi({
    reducerPath: 'ApplicationsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["APPLICATION"],
    endpoints: builder => ({
        getApplication: builder.query<Application, { id: number }>({
            query: id => ({ url: `/application/${id}` }),
            providesTags: ["APPLICATION"],
        }),
        getAllApplications: builder.query<Application[], void>({
            query: () => ({ url: '/application' }),
            providesTags: ["APPLICATION"],
        }),
        createApplication: builder.mutation<any, ApplicationDto>({
            query: (data)=> ({url: `/application`, method: "POST", body: data}),
            invalidatesTags: ["APPLICATION"],
        }),
    })
})

export const { useGetApplicationQuery, useGetAllApplicationsQuery, useCreateApplicationMutation } = ApplicationsApi
